var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button__quick-exit",attrs:{"href":"https://www.google.com"},on:{"click":function($event){$event.preventDefault();return _vm.exit()}}},[_c('span',[_vm._v("Quick exit (esc)")]),_c('close-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }